import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatCount, formatTaka } from '@/utils/number';
import { createPcmpRedisburseBatch } from '../api/pcmpAccounts.api';
import type {
  PcmpRedisburseCreatePayload,
  PcmpRedisburseCreateResult,
} from '../types/pcmpAccounts.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useCreatePcmpRedisburseBatch(
  onSuccess: (result: PcmpRedisburseCreateResult) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpRedisburseCreatePayload) => createPcmpRedisburseBatch(payload),
    ...pcmpActionCallbacks<PcmpRedisburseCreateResult>(
      queryClient,
      (result) =>
        `Re-disbursement batch #${result.batchNo} created: ${formatCount(
          result.added.length,
          'proposal',
        )} (${formatTaka(result.addedAmount)})`,
      onSuccess,
    ),
  });
}
